<template>
  <v-card>
    <v-card-text>
      <b-row no-gutters>
        <b-col cols="12">
          <v-data-iterator
            disable-sort
            :items="deploy_scripts"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:[`default`]="{ items }">
              <b-form-radio-group
                stacked
                text-field="name"
                value-field="id"
                :options="items"
                v-model="deploy_script_id"
              >
              </b-form-radio-group>
            </template>
          </v-data-iterator>
        </b-col>
        <b-col cols="12">
          <errors-messages :errors="errors" />
        </b-col>
        <b-col cols="12" class="text-right">
          <v-btn @click="execute" text color="primary"> EXECUTAR </v-btn>
        </b-col>
      </b-row>
    </v-card-text>
  </v-card>
</template>

<script>
import toast from "../../components/ToastNotification";
import api from "../../services/api";
import ErrorsMessages from "../components/ErrorsMessages.vue";
export default {
  components: { ErrorsMessages },
  name: "RestHomeDeployment",

  props: {
    rest_home_id: [Number, String],
  },

  data() {
    return {
      errors: [],
      loading: false,

      deploy_script_id: null,
      deploy_scripts: [],
    };
  },

  created() {
    this.getScripts();
  },

  methods: {
    async getScripts() {
      try {
        this.loading = true;

        const response = await api.get("/admin/rest-home-deploy-scripts");
        const { error, errors, deploy_scripts } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.deploy_scripts = deploy_scripts;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async execute() {
      try {
        this.loading = true;

        const data = {
          rest_home_id: this.rest_home_id,
          deploy_script_id: this.deploy_script_id,
        };
        const response = await api.post("/admin/rest-home-deploy-script", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>